import Vue from 'vue'
import VueRouter from 'vue-router'
import app from './app.js'
import store from './store/index'
import Images from './components/Images'
import Pages from './components/Pages'
import Dashboard from './components/admin/Dashboard'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	routes: [
		{
			name: 'images',
			path: '/images/:from/:to',
			component: Images,
			props: {
				displayHeader: true,
				displaySearchbar: true
			}
		}, {
			name: 'reported-images',
			path: '/reported-images',
			component: Images,
			props: {
				displayHeader: true,
				displaySearchbar: false
			}
		}, {
			name: 'document',
			path: '/doc/:id',
			component: Pages,
			props: {
				displayHeader: true,
				displaySearchbar: true
			}
		}, {
			name: 'dashboard',
			path: '/dashboard',
			component: Dashboard
		},
	]
})

export default router